import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPivotIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 3v6m0 6v6m-9-9h6m6 0h6" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 2.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 6,
			strokeWidth: 1.5,
			opacity: .4
		})
	]
});
export default SvgPivotIcon;
